/**
 * @fileOverview When the component is mounted we want to force it into view
 * @name ScrollIntoView.js
 * @author Christian Parker <chris@talloaks.io>
 * @license no license
 */
export default {
  mounted() {
    // scroll on mount
    if(this.$route.hash){
      this.scrollTo(this.$route.hash);
    } else {
      this.scrollIntoView();
    }
  },
  watch: {
    uid(a){
      // if the page has changed we scroll to the top
      if(a) this.$el.scrollIntoView();
    },
    '$route.hash'(a){
      if(a) {
        this.scrollTo(a);
      } else {
        this.scrollIntoView();
      }
    }
  },
  methods: {
    scrollIntoView(){
      this.$el.scrollIntoView();
    },
    scrollTo(id){
      const el = document.getElementById(id.replace('#',''));
      if (el) {
        el.scrollIntoView({
          // behavior: 'smooth'
        });
      }
    }
  }
};
